import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=68df47d3&scoped=true&lang=pug&"
import script from "./Puzzle.vue?vue&type=script&lang=js&"
export * from "./Puzzle.vue?vue&type=script&lang=js&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&id=68df47d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df47d3",
  null
  
)

export default component.exports